import { i18nFilter } from "app/filters/i18nFilter";
import {
    ClaimedTitle,
    Link,
    SubTitle,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/Card.styled";
import { EVENTS_CATEGORY } from "app/pages/digital-suite/home-page/components/Rewards/utils/consts";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { allTrackers } from "app/services/track/track";
import { goToPackagesPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";

interface IClaimedCardProps {
    cardItem: IPackage;
}

const ClaimedCard = ({ cardItem }: IClaimedCardProps) => {
    const i18n = i18nFilter();
    const { DiscountPercentage } = cardItem;

    const handleClaimClick = () => {
        allTrackers.trackEvent(EVENTS_CATEGORY, "click", `Claim Reward/${DiscountPercentage}`);
        goToPackagesPage();
    };

    return (
        <>
            <ClaimedTitle>
                {i18n("rewards_modal.main_screen.rewards_section.claimed_card.title", { discount: DiscountPercentage })}
            </ClaimedTitle>
            <SubTitle>
                {i18n("rewards_modal.main_screen.rewards_section.claimed_card.subtitle.prefix")}
                <Link onClick={handleClaimClick}>
                    {i18n("rewards_modal.main_screen.rewards_section.claimed_card.subtitle.link")}
                </Link>
                {i18n("rewards_modal.main_screen.rewards_section.claimed_card.subtitle.suffix")}
            </SubTitle>
        </>
    );
};

export default ClaimedCard;
